import {cloneElement} from 'react';

const ComputeStyle = ({getComputedStyle, children, ...props}) => {
    const style = getComputedStyle(props);

    return cloneElement(children, {style});
};

export default ComputeStyle;
